import { DATA_METRICS } from '../componentKeys.js'

const identifiers = {
  key: 'dynamicDupeUploads',
  type: 'call',
  access: 'stats',
}

const formatting = {
  format: {
    title: 'Duplicate Dynamic Uploads',
  },
}

const keys = {
  statKey: 'posted_dupe_prospects',
  componentKeys: [DATA_METRICS],
  healthKey: 'metric_health',
}

const calculation = {
  calcType: 'aggregate',
}

const dynamicDupeUploads = {
  metaData: Object.assign(identifiers, formatting, keys, calculation),
  calculationConfig: calculation,
}

export { dynamicDupeUploads }
